import { CONSENT_TO_PRIVACY_POLICY_SETTING, MemberSettings } from '../meraki-models/member.models';
import { fromTimestamp } from '../meraki-models/meraki-model-util';

export enum PRIVACY_POLICY_STATUS {
  ACCEPTED = 'Accepted',
  NOT_ACCEPTED = 'Not accepted',
  NOT_RECORDED = 'Not recorded',
}

export interface PatientPrivacyPolicyViewModel {
  status: PRIVACY_POLICY_STATUS;
  acceptedOn?: Date;
  version?: string;
}

export function toPatientPrivacyPolicy(settings: MemberSettings): PatientPrivacyPolicyViewModel {
  switch (settings?.ConsentToPrivacyPolicy) {
    case CONSENT_TO_PRIVACY_POLICY_SETTING.YES:
      return {
        status: PRIVACY_POLICY_STATUS.ACCEPTED,
        acceptedOn: fromTimestamp(settings.ConsentToPrivacyPolicyDate),
        version: settings.ConsentToPrivacyPolicyVersion || null,
      };
    case CONSENT_TO_PRIVACY_POLICY_SETTING.NO:
      return { status: PRIVACY_POLICY_STATUS.NOT_ACCEPTED };
    default:
      return { status: PRIVACY_POLICY_STATUS.NOT_RECORDED };
  }
}

function privacyPolicyNeedsAttention(privacyPolicy: PatientPrivacyPolicyViewModel): boolean {
  return !!privacyPolicy && privacyPolicy.status !== PRIVACY_POLICY_STATUS.ACCEPTED;
}

export function privacyPolicyNavIndicator(privacyPolicy: PatientPrivacyPolicyViewModel): string {
  return privacyPolicyNeedsAttention(privacyPolicy) ? 'Practice privacy policy needs attention' : null;
}

export function privacyPolicyWarningHeader(privacyPolicy: PatientPrivacyPolicyViewModel): string {
  if (!privacyPolicyNeedsAttention(privacyPolicy)) {
    return null;
  }
  return privacyPolicy.status === PRIVACY_POLICY_STATUS.NOT_ACCEPTED
    ? 'Practice privacy policy not accepted'
    : 'Practice privacy policy not recorded';
}
